import { render } from "./POSKioskPage.vue?vue&type=template&id=6ecd85ec"
import script from "./POSKioskPage.vue?vue&type=script&lang=js"
export * from "./POSKioskPage.vue?vue&type=script&lang=js"

import "./POSKioskPage.vue?vue&type=style&index=0&id=6ecd85ec&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__